import { createContext, ReactNode, useCallback, useContext, useState } from "react";

export type ErrorState = {
    has404Error: boolean;
    reportError: (statusCode: number) => void;
}

export const ErrorHandlingContext = createContext<ErrorState | undefined>(undefined);

export const ErrorHandlingProvider = ({ children }: { children: ReactNode }) => {
    const [has404Error, SetHas404Error] = useState<boolean>(false);

    const reportError = useCallback((statusCode: number) => {
        if (statusCode != 404) return;
        console.log("hola")

        SetHas404Error(true);
    }, [])

    return (
        <ErrorHandlingContext.Provider value={{ has404Error, reportError }}>
            {children}
        </ErrorHandlingContext.Provider>
    );
}

export function useErrorHandling() {
    const context = useContext(ErrorHandlingContext);
    if(context == undefined)
        throw new Error("useErrorHandling debe ser usado dentro de ErrorHandlingContext.");
    return context;
}